<template>
  <div class="pt-2 px-2">
    <p>
      <span v-if="isShowFull" v-html="fullText"></span>
      <span v-if="!isShowFull" v-html="haftText"></span>
      <span v-if="!isShowFull && fullText.length > 150">... <br><span class="text-info" @click="showAll()">Xem thêm</span></span>
      <span v-if="isShowFull && fullText.length > 150"><br><span class="text-info" @click="hideLess()">Ẩn bớt</span></span>
    </p>
    <p class="text-center"><span v-if="!correctTags.length && !correctVoiceTags.length && !inCorrectTags.length">-</span></p>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      folder: null,
      normalQuestions: [],
      tag: null,
      tagMap: {
        Listening: {
          allCorrect: {
            text: 'Con đã nghe, nhận biết và vận dụng tốt các từ và cấu trúc ngữ pháp: {text} vào các dạng bài tập.',
            color: '#00CC60',
          },
          voiceCorrect: {
            text: 'Đặc biệt, đọc đúng các từ và câu: {text}.',
            color: '#00CC60',
          },
          incorrect: {
            text: 'Con cần dành thời gian luyện nghe nhiều hơn với các từ và cấu trúc ngữ pháp: {text}.',
            color: '#FF6500',
          },
        },
        Reading: {
          allCorrect: {
            text: 'Con đã làm tốt khi đọc hiểu và ghi nhớ, nhận biết được các từ và cấu trúc ngữ pháp: {text} có trong Unit này.',
            color: '#00CC60',
          },
          voiceCorrect: {
            text: 'Đặc biệt, đọc đúng các từ và câu: {text}.',
            color: '#00CC60',
          },
          incorrect: {
            text: 'Các từ vựng và cấu trúc ngữ pháp như: {text} con cần luyện tập thêm nhé!',
            color: '#FF6500',
          },
        },
        Writing: {
          allCorrect: {
            text: 'Con đã nhớ cách viết và vận dụng tốt các từ và cấu trúc ngữ pháp: {text} vào các dạng bài tập có trong để kiểm tra.',
            color: '#00CC60',
          },
          voiceCorrect: {
            text: 'Đặc biệt, đọc đúng các từ và câu: {text}.',
            color: '#00CC60',
          },
          incorrect: {
            text: 'Con cần ôn tập lại các từ và cấu trúc ngữ pháp: {text} để tránh lỗi sai mà con đang mắc phải khi làm bài nhé!',
            color: '#FF6500',
          },
        },
      },
      mapQuestion: null,
      correctTags: [],
      inCorrectTags: [],
      correctVoiceTags: [],
      voiceQuestions: [],
      isShowFull: false,
      fullText: '',
      haftText: '',
    };
  },
  mounted() {
    const correctTags = [];
    const inCorrectTags = [];
    const correctVoiceTags = [];
    this.mapQuestion = this.tagMap[this.type];
    this.folder = this.item.folders.find((item) => item.name === this.type);
    this.normalQuestions = this.item.questions.filter((item) => (item.folder_id === this.folder.id && item.type.code_text !== 'voice'));
    this.voiceQuestions = this.item.questions.filter((item) => (item.folder_id === this.folder.id && item.type.code_text === 'voice'));
    let allTagOfFolder = [];
    this.normalQuestions.forEach((itemQuestion) => {
      allTagOfFolder = allTagOfFolder.concat(itemQuestion.tags);
    });
    this.voiceQuestions.forEach((itemQuestion) => {
      allTagOfFolder = allTagOfFolder.concat(itemQuestion.tags);
    });
    this.item.tags.forEach((itemTag) => {
      let flag = false;
      let flagVoice = false;
      this.normalQuestions.forEach((itemQuestion) => {
        if (itemQuestion.tags.includes(itemTag.id) && itemQuestion.result && itemQuestion.result.is_correct) {
          flag = true;
        }
      });

      if (flag && allTagOfFolder.includes(itemTag.id)) {
        correctTags.push(itemTag.title);
      }
      if (!flag && allTagOfFolder.includes(itemTag.id)) {
        inCorrectTags.push(itemTag.title);
      }

      this.voiceQuestions.forEach((itemQuestion) => {
        if (itemQuestion.tags.includes(itemTag.id) && itemQuestion.result && itemQuestion.result.is_correct) {
          flagVoice = true;
        }
      });

      if (flagVoice) {
        correctVoiceTags.push(itemTag.title);
      }
    });

    this.correctTags = correctTags;
    this.inCorrectTags = inCorrectTags;
    this.correctVoiceTags = correctVoiceTags;
    this.loadAllText();
  },
  methods: {
    showText(textItem, arrTags) {
      arrTags.sort((a, b) => parseFloat(a.length) - parseFloat(b.length));
      const tagStr = `<span style="color:${textItem.color}">${arrTags.join(', ')}</span>`;

      return textItem.text.replace('{text}', tagStr);
    },
    showAll() {
      this.isShowFull = true;
    },
    hideLess() {
      this.isShowFull = false;
    },
    loadAllText() {
      if (this.correctTags.length) {
        this.correctTags.sort((a, b) => parseFloat(a.length) - parseFloat(b.length));
        const tagStrCr = `<span style="color:${this.mapQuestion.allCorrect.color}">${this.correctTags.join(', ')}</span>`;
        this.fullText += this.mapQuestion.allCorrect.text.replace('{text}', tagStrCr);
        this.fullText += '<br>';
      }

      if (this.correctVoiceTags.length) {
        this.correctVoiceTags.sort((a, b) => parseFloat(a.length) - parseFloat(b.length));
        const tagStrV = `<span style="color:${this.mapQuestion.voiceCorrect.color}">${this.correctVoiceTags.join(', ')}</span>`;
        this.fullText += this.mapQuestion.voiceCorrect.text.replace('{text}', tagStrV);
        this.fullText += '<br>';
      }

      if (this.inCorrectTags.length) {
        this.inCorrectTags.sort((a, b) => parseFloat(a.length) - parseFloat(b.length));
        const tagStrI = `<span style="color:${this.mapQuestion.incorrect.color}">${this.inCorrectTags.join(', ')}</span>`;
        this.fullText += this.mapQuestion.incorrect.text.replace('{text}', tagStrI);
      }

      this.haftText = this.fullText.slice(0, 150);
    },
  },
};
</script>
<style lang="scss" scoped>
  .text-info {
    color: #1187CA;
  }
</style>
<style lang="scss">
</style>
